import { BILLING_RECAPTCHA_SITE_KEY } from 'constants/runtimeConfig';

export const SITE_KEY = '6Lc__JwUAAAAAOUdT_saPmzmUEuTP0YpBXUe_6gu';
export const INVISIBLE_SITE_KEY = window.Cypress
  ? '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI'
  : '6Ld-n7oUAAAAAJXKlolGKP7fPZhf-JmnXayt9PN5';
export const BILLING_SITE_KEY = BILLING_RECAPTCHA_SITE_KEY;
